import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue'
import { addWarningContact, updateWarningContact } from '@/api'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { phoneReg, CODE_ENUM } from '@/common'
import { isEmpty } from 'lodash'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'contact-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




const formData = ref({
  name: '',
  mail: '',
  phone: '',
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      if (!isEmpty(props.data)) {
        const { name, mail, phone } = props.data
        formData.value = {
          name,
          mail,
          phone,
        }
      }
    } else {
      formRef.value.resetFields()
    }
  }
)

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const vailidateMethod = (reg: RegExp, msg: string) => {
  return (rule: any, value: any, callback: any) => {
    if (reg.test(value)) {
      callback()
    } else {
      callback(msg)
    }
  }
}

const rules: any = {
  name: [{ required: true, message: t('W_CONTACT.enter') }],
  mail: [
    { required: true, message: t('W_CONTACT.select') },
    {
      type: 'email',
      message: t('W_CONTACT.emailMsg'),
    },
  ],
  phone: [
    { required: true, message: t('W_CONTACT.enter') },
    {
      validator: vailidateMethod(phoneReg, t('W_CONTACT.phoneMsg')),
    },
  ],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleAddDevice = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = props.data.reachUserId
        ? updateWarningContact
        : addWarningContact
      const res: any = await fn({
        ...formData.value,
        reachUserId: props.data.reachUserId,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: res?.msg,
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: 
      props.data.reachUserId
        ? _ctx.$t('W_CONTACT.titleEdit')
        : _ctx.$t('W_CONTACT.titleNew')
    ,
    width: "500px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('W_CONTACT.btnCancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleAddDevice
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('W_CONTACT.btnYes')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "name",
              label: _ctx.$t('W_CONTACT.labelName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "phone",
              label: _ctx.$t('W_CONTACT.labelPhone')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event)),
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "mail",
              label: _ctx.$t('W_CONTACT.labelMail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.mail,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.mail) = $event)),
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})